<template>
    <ConfirmDialog
        :open="state.isOpen"
        :title="state.options.title"
        :confirm-label="state.options.confirmLabel"
        :cancel-label="state.options.cancelLabel"
        :tone="state.options.tone"
        @confirm="confirm"
        @cancel="cancel"
    >
        <p v-if="state.options.message" class="confirm-host__message">{{ state.options.message }}</p>
    </ConfirmDialog>
</template>

<script setup>
import ConfirmDialog from './ConfirmDialog.vue';
import { useConfirm } from '../../composables/useConfirm';

const { state, confirm, cancel } = useConfirm();
</script>

<style scoped>
.confirm-host__message {
    white-space: pre-line;
}
</style>
